/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemSpace } from "./d-theme-white-menu-item-expandable-item-space";

export class DThemeWhiteMenuSidedItemExpandableItemSpace extends DThemeWhiteMenuItemExpandableItemSpace {}
